import WarningTagsTable from 'components/WarningTags';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const WarningTags = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isWarningTagsPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'WarningTags',
    permission: ['viewAll'],
  });
  return <div>{isWarningTagsPermission && <WarningTagsTable />}</div>;
};
